export default __webpack_public_path__ + "static/media/plbgcircle3.69f1c057.png";